/* eslint-disable no-param-reassign */
import localforage from 'localforage';

const getTimestamp = () => {
  const currentDate = new Date();
  const convertedDate = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), currentDate.getUTCHours(), currentDate.getUTCMinutes(), currentDate.getUTCMinutes(), currentDate.getUTCMilliseconds());
  return convertedDate.valueOf();
}

const logErrorToBucket = (error) => {
  // return fetch(`/hit.error`, { 
  //   credentials: "same-origin", 
  //   body: JSON.stringify(obj), 
  //   method: "post",
  //   headers: new Headers({ 'Content-Type': 'application/json' })
  // })
  //   .then(res => { return res.ok; })
  //   .catch(err => { return false; });
  console.error(error);
}
const telemetryStore = {
  namespaced: true,
  state: {
    telemetryUrl: null,
    collection: null,
    telemetryPoll: null,
    retryCount: 0
  },
  mutations: {
    
  },
  actions: {
    addEvent({ state }, payload) {
      state.collection.setItem(`${payload.timestamp}`, payload);
    },
    uploadEventBuffer({ state }) {
      // Pull from index db collection
      const events = [];
      return state.collection.iterate((value) => { 
        events.push({ ...value });
      })
        .then(async () => {
          if (!events.length) return;
          const serverModel = {
            events,
            userAgent: navigator.userAgent,
            locale: navigator.language
          }
          const res = await fetch('/v2/feed/telemetry', {
            body: JSON.stringify(serverModel),
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json' })
          });
          if (res.ok) {
            state.collection.clear();
          } else {
            // log the error
            console.error(await res.text());
            // see if the retry limit of 5 has been hit
            const retryCountLimitHit = state.retryCount >= 5;
            // if it was hit
            if (retryCountLimitHit) {
              // reset it to 0
              state.retryCount = 0;
              // and clean up the collection
              state.collection.clear();
            } else {
              state.retryCount++;
            }
          }
        });
    },
    startEventPolling({ state, dispatch }, payload) {
      state.telemetryPoll = setInterval(() => {
        dispatch('uploadEventBuffer');
      }, payload.pollingInterval)
    }
  }
}

const KyAnalytics = {
  install(Vue, options) {
    if (options.analytics.enabled) {
      if (!options.store) {
        console.error('You must pass in an instance of a Vuex store.');
        return;
      }
      if (!options.router) {
        console.error('You must pass in an instance of a Vue router.');
        return;
      }
      telemetryStore.state.telemetryUrl = options.analytics.telemetryUrl;
      telemetryStore.state.collection = localforage.createInstance({
        name: 'UserAppSettings',
        storeName: 'telemetry'
      });
      options.store.registerModule('telemetry', telemetryStore);
      Vue.prototype.$kya = {
        /**
         * Adds an event to the store.
         * @param {string} categoryName 
         * @param {string} eventName 
         * @param {string} label 
         * @param {string} params 
         */
        event: async (categoryName, eventName, label, params) => {
          await options.store.dispatch('telemetry/addEvent', {
            timestamp: getTimestamp(), 
            categoryName, 
            eventName, 
            label, 
            params 
          });
        },
        init: () => {
          options.store.dispatch('telemetry/startEventPolling', { pollingInterval: options.analyticsPollingInterval || 60000 });
        }
      }
      // we can hook into the router here to get names, full paths, and more
      options.router.afterEach((to, from) => {
        if (to.name == 'signinwin-kppnext') return;
        const obj = {
          timestamp: getTimestamp(),
          categoryName: to.name,
          eventName: 'navigate',
          label: `Navigate to ${to.name}`,
          params: { from: from.fullPath, to: to.fullPath }
        }
        options.store.dispatch('telemetry/addEvent', obj);
      });
    }
    if (options.errors.enabled) {
      // error handling
      // eslint-disable-next-line no-param-reassign
      Vue.config.errorHandler = (err, vm, info) => {
        if (!err) {
          // eslint-disable-next-line no-param-reassign
          err = { message: 'Unknown error has occurred.' }
        }
        const obj = {
          route: vm.$route.fullPath,
          message: err.message,
          stack: err.stack,
          actionContext: info
        }
        if (options.errors.console) {
          console.error(obj);
        }
        const isAdmin = vm.$hasRole('Super User,Kymeta Admin');
        const { detailedErrors } = vm.$store.state.user.settings;
        if (isAdmin && detailedErrors) {
          if (vm.$buefy) {
            vm.$buefy.snackbar.open({
              indefinite: true,
              message: `<p style="margin-bottom: 8px"><strong>Unexpected error:</strong> ${err.message}.</p>
              <p style="margin-bottom: 8px">${obj.stack}</p>
              <ul>
                <li>Please contact Cloud Services.</li>
              </ul>`,
              type: 'is-danger',
              position: 'is-bottom-right',
              actionText: 'OK',
              queue: false,
              onAction: () => {
                logErrorToBucket(obj);
              }
            })
          }
        } else {
          vm.$buefy.toast.open({
            duration: 5000,
            message: 'An unexpected error occurred. Customer support has been notified.',
            position: 'is-bottom-right',
            type: 'is-danger'
          })
          logErrorToBucket(obj);
        }
      }
    }
  }
}
export default KyAnalytics;
